<ng-lottie [options]="lottieConfig" (animationCreated)="onAnimationCreated($event)"></ng-lottie>
